<template>
  <v-btn
    icon
    :loading="readFilesLoading"
    class="ma-0"
    :disabled="disabled"
    @click="upload"
  >
    <v-icon>publish</v-icon>
  </v-btn>
</template>

<script>
import upload from "./attachments/upload.js";

export default {
  props: ["disabled"],
  data() {
    return {
      readFilesLoading: false,
      file: {},
    };
  },
  methods: {
    upload() {
      upload().then(file => {
        this.file = file[0];
        this.file.type = 1;
        this.$emit("upload", this.file);
        this.file = {};
      });
    },
  },
};
</script>
